<template>
  <loading-wrapper
    :loading="loading"
    class="section center"
  >
    <div
      v-if="selectedEmployee"
      class="container center max-width-mobile"
    >
      <div class="tipping-share-card">
        <router-link
          v-slot="{ href }"
          :to="{ name: 'employeeTipping' }"
        >
          <div class="tipping-share-card--content">
            <div class="centered flex-column align-center">
              <div
                v-if="selectedEmployee.photoUrl"
                class="tipping-share-card--image tipping-share-card--image__employee"
                :style="{ 'background-image': `url(${selectedEmployee.photoUrl})` }"
              />
              <h2 class="title title--2 no-spacing">{{ fullName }}</h2>
              <p class="dark-gray">Department: <b>{{ selectedDepartment.name }}</b></p>
            </div>

            <vue-qrcode
              class="image tipping-share-card--qr-code"
              :value="`${baseUrl}${href}`"
              :width="500"
              :margin="0"
            />

            <div class="buttons justify-center">
              <a
                target="_blank"
                :href="href"
                class="button button--small button--primary button--auto-width"
              >
                <span class="icon far fa-external-link" />
                View Page
              </a>

              <button
                v-copy-to-clipboard="{ value: `${baseUrl}${href}` }"
                type="button"
                class="button button--small button--secondary button--auto-width"
              >
                <span class="icon far fa-copy" />
                Copy Link
              </button>
            </div>
          </div>
        </router-link>
      </div>

      <div class="flex-column align-center dist-y-half spacing">
        <a
          class="cursor-pointer flex"
          target="_system"
          @click="addToAppleWallet"
        >
          <img
            style="height: var(--input-height)"
            src="/images/apple-wallet.svg"
          >
        </a>
        <a
          target="_blank"
          class="cursor-pointer flex"
          :href="selectedEmployee.googleWalletLink"
        >
          <img
            style="height: var(--input-height)"
            src="/images/google-pay-save.svg"
          >
        </a>
      </div>
    </div>
  </loading-wrapper>
</template>

<script>
  import { fetchEmployeeAppleWalletPass } from '@/services/api/mobile-tipping';
  import errorHandlers from '@/services/error-handlers';
  import { downloadPkpass } from '@/helpers/download-apple-wallet-pass';
  import { mapGetters } from 'vuex';

  export default {
    name: 'EmployeeSharePage',

    metaInfo() {
      return {
        title: this.fullName
      };
    },

    data: () => ({
      loading: true
    }),

    computed: {
      ...mapGetters('hotels', ['selectedEmployee', 'selectedDepartment']),

      baseUrl() {
        return window.location.origin;
      },

      fullName() {
        return [
          this.selectedEmployee?.firstName,
          this.selectedEmployee?.lastName
        ].join(' ').trim();
      }
    },

    created() {
      this.onCreated();
    },

    methods: {
      async onCreated() {
        await this.$store.dispatch('hotels/fetchEmployee', this.$route.params.employeeId);
        await this.$store.dispatch('hotels/fetchEmployeeGoogleWalletLink', {
          employeeId: this.$route.params.employeeId,
          params: {
            // still need to iron out exactly what values will be passed here
            displayName: this.fullName
          }
        });
        this.loading = false;
      },

      async addToAppleWallet() {
        const { data: pkPassData, error } = await fetchEmployeeAppleWalletPass(this.$route.params.employeeId, {
          // still need to iron out exactly what values will be passed here
          displayName: this.fullName
        });
        if (error) errorHandlers.generic(error);
        else downloadPkpass(pkPassData, this.$route.params.employeeId);
      }
    }
  };
</script>
